import * as React from 'react';
import type { CurrentUser } from '@/app-package';

type OfferAgentProps = {
  user: CurrentUser;
  phoneNumber: string;
  onPhoneNumberChange: (phoneNumber: string) => void;
};

const OfferAgent: React.FunctionComponent<OfferAgentProps> = ({
  user,
  phoneNumber,
  onPhoneNumberChange,
}) => (
    <>
      <div className="form-group">
        {user.firstName} {user.lastName}
      </div>

      <div className="form-group">
        <h5>{user.org.mls_name}</h5>
        {
          user.org.addresses[Number(user.location)][Number(user.address)]
            .address
        }
        <br />
        Tel:{' '}
        {user.org.addresses[Number(user.location)][Number(user.address)].phone}
      </div>

      <div className="form-group">
        <label>Email:</label> {user.email}
      </div>

      <div className="form-group">
        <label>Mobile:</label>
        <input
          type="text"
          className="form-control"
          value={phoneNumber}
          onChange={e => onPhoneNumberChange(e.target.value)}
          required
          placeholder="Mobile"
          style={{ width: '200px' }}
        />
        {!phoneNumber && (
          <label className="error">Phone number is required.</label>
        )}
      </div>
    </>
  );

export default OfferAgent;
